export enum QUICK_SEARCH_FILTERS {
  ALL = 'all',
  BENCHMARK_PROXIES = 'benchmark_proxies',
  BENCHMARKS = 'benchmarks',
  BONDS = 'bonds',
  FAVORITE = 'favorite',
  FUNDS = 'funds',
  PROXIES = 'proxies',
  SIMULATION = 'simulation',
  SMA = 'sma',
  STOCKS = 'stocks',
  ALTS = 'alts',
}

export enum QUICK_SEARCH_PILL_LABELS {
  BONDS = 'bonds',
  CASH = 'cash',
  ETF = 'ETF',
  FUNDS = 'funds',
  GIC = 'GIC',
  HISA = 'HISA',
  Indices = 'proxy',
  SMA = 'SMA',
  STOCKS = 'stocks',
  ALTS = 'alts',
}
